import { IMapFeatureText, IMapTextOptions } from "../types";
import { ol_style, ol_geom } from "@omnia/exports/openlayers";

export function getTextStyles(resolution: number, styles: IMapFeatureText[], options?: IMapTextOptions): ol_style.Style[] {

    let { offsetY = 0, baseStyle, coord, line, backgroundFill, padding, rotation, textBaseline, placement, zIndex } = options || <Partial<IMapTextOptions>>{}

    const geom = line || (coord ? new ol_geom.Point(coord) : undefined)

    return styles.map(ts => {

        var fontSize = 10;
        var text = "";

        if (resolution && (resolution <= 20)) {
            fontSize += 14 / resolution;
        };

        text = ts.text;
        fontSize = (ts.fontSize || fontSize);

        if (ts.fontSizeOffset) {
            fontSize += ts.fontSizeOffset;
        };

        baseStyle = baseStyle || getTextBaseStyle()

        baseStyle["backgroundFill"] = backgroundFill
        baseStyle["padding"] = padding
        baseStyle["exceedLength"] = true
        baseStyle["overflow"] = true

        if (rotation) {
            baseStyle["rotation"] = rotation
        }

        if (textBaseline) {
            baseStyle["textBaseline"] = textBaseline
        }

        if (placement) {
            baseStyle["placement"] = placement
        }

        const style = new ol_style.Text(baseStyle)

        style.setText(text);
        style.setFont((ts.italic ? "italic " : "") + (ts.bold ? "bold " : "") + fontSize + "px 'Open Sans',Arial,sans-serif");
        style.setOffsetY(offsetY);

        offsetY += (fontSize * 1.25);

        return new ol_style.Style({
            text: style,
            geometry: geom,
            zIndex
        });

    });

}

export function getTextBaseStyle() {

    return {
        fill: new ol_style.Fill({ color: "#fff" }),
        stroke: new ol_style.Stroke({ color: "#444", width: 2 }),
        overflow: true
    };

}
